import { Badge, Box, Chip } from "@mui/material";
import { DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import React, { ReactNode } from "react";

export type chipColor = "green" | "purple" | "red" | "petalCyan";
export type statusChipStatus = "green" | "lightgreen" | "red" | "purple" | "orange" | "yellow" | "grey";

export interface StatusChipColor {
    background: string;
    text: string;
    dot: string;
}

export const statusChipColors: Record<statusChipStatus, StatusChipColor> = {
    green: { background: "#E6FAED", text: "#36847D", dot: "#2BD5C4" },
    lightgreen: { background: "#ECFBFD", text: "#1A8092", dot: "#11CCE5" },
    red: { background: "#FEE4E2", text: "#B70036", dot: "#FF3F78" },
    purple: { background: "#E1E7FD", text: "#2C2A90", dot: "#353494" },
    orange: { background: "#FFF4E5", text: "#B85C00", dot: "#FF9F40" },
    yellow: { background: "#FEF7C3", text: "#A15C07", dot: "#FAC515" },
    grey: { background: "#F2F4F7", text: "#667085", dot: "#98A2B3" },
};

export interface StatusChipProps {
    value: string;
    status: statusChipStatus;
    hideDot?: boolean;
    addBorder?: boolean;
    toolTip?: ReactNode;
}

function StatusChip(props: StatusChipProps) {
    const { background: bgColor, text: color, dot: dotColor } = statusChipColors[props.status];

    function getChip() {
        let chip = (
            <Chip
                sx={{
                    padding: 1,
                    color: color,
                    backgroundColor: bgColor,
                    border: props.addBorder ? "1px solid" : "unset",
                    "& .MuiBadge-root.MuiChip-icon": {
                        marginRight: "1px",
                    },
                    "& .MuiBadge-badge": {
                        backgroundColor: dotColor,
                    },
                }}
                size={"small"}
                icon={props.hideDot ? undefined : <Badge variant={"dot"} color="primary" />}
                label={props.value}
            />
        );

        if (props.toolTip) {
            return <DotLegalTooltip text={props.toolTip}>{chip}</DotLegalTooltip>;
        }

        return chip;
    }

    return <>{getChip()}</>;
}

export default StatusChip;
